module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-list-page"
  }, [_c('ad-block'), _vm._v(" "), _c('h2', [_vm._v("Автоматический генератор ссылок по ГОСТ онлайн")]), _vm._v(" "), _c('simple-list-container'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57c6f271"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SimpleListPage.vue
// module id = 1008
// module chunks = 1